import { EditProfileForm } from '@/features/profile/editProfileForm';

export const EditProfilePage = () => {
	return <EditProfileForm />;
};
